<template>
  <div class="factoring-container">
    <div class="project-table">
      <avue-crud
        ref="crud"
        :option="tableConfig"
        :data="tableData"
        v-model="form"
        :page.sync="page"
        :search.sync="searchForm"
        :table-loading="loading"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @selection-change="selectionChange"
        @row-save="rowSave"
        @row-update="rowUpdate"
      >
        <template slot="leaseName" slot-scope="{ row }">
          <div class="project-name" @click="handleDetails(row.id)">
            {{ row.leaseName }}
          </div>
        </template>
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            :disabled="readOnly"
            @click.stop="handleAdd()"
            >新增
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            :disabled="readOnly"
            @click.stop="handleEdit()"
            >编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            :disabled="readOnly"
            @click.stop="handleDelete()"
            >删除
          </el-button>
        </template>
      </avue-crud>
    </div>
    <Verification ref="verif" />
  </div>
</template>
<script>
import { logisticsInventoryConfig } from "./config";
import * as api from "@/api/factoring/factoring";
import util from "@/mixins/util";
import Verification from "./verificationVisible";
export default {
  name: "logisticsInventory",
  mixins: [util],
  data() {
    return {
      selectionList: [],
      checkUserList: [],
      checkdepartment: [],
      form: {},
      // filterSearchForm: {},
      files: "",
      drawer: false,
      id: "",
      tableConfig: logisticsInventoryConfig(this.getMoney),
      sortOption: "",
      optionColumn: {},
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      loading: false,
    };
  },
  props: {
    
    // 只读 禁用
    readOnly: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Verification,
  },
  computed: {},

  mounted() {
    this.sortOption = this.tableConfig.column;

    // this.queryTableData();
  },
  methods: {
    selectionChange(list) {
      this.selectionList = list;
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },

    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    async queryTableData() {
      this.loading = true;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
      };
      let res = await api.getCollateralList(params);
      if (res.data.code == 200) {
        let data = res.data.data.records;

        this.tableData = data;
        this.page.total = res.data.data.total;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },

    //新增
    handleAdd() {
      Object.assign(this.form, {});
      this.$refs.crud.rowAdd();
    },
    //新增
    rowSave(row, done, loading) {
      this.submitCustcarbl(row, done, loading);
    },
    //修改
    rowUpdate(row, index, done, loading) {
      this.submitCustcarbl(row, done, loading);
    },
    // 新增修改 接口
    submitCustcarbl(row, done, loading) {
      let data = {
        ...row,
        id: this.id > -1 ? this.id : undefined,
      };
      api.submitCollateral(data).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
          this.queryTableData();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        this.virtualId = data.id;

        this.$refs.crud.rowEdit(data);
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    handleDelete() {
      let self = this;

      this.$confirm("确定删除选择的数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
         
          let ids = this.selectionList.map((item) => {
            return item.id;
          });
          let res = await api.removeCollateral({ ids: ids.join(",") });
          if (res.data.code == 200) {
            self.$message({
              type: "success",
              message: "删除成功",
            });
            self.queryTableData();
          }
        })
        .catch(() => {});
    },
    // 显示详情
    handleDetails(id) {
      this.$refs.verif.showblock(id);
      // this.$router.push({ path: `/zd/bankmanage/bankmanageDetail/${id}` });
    },
  },
};
</script>
<style lang="scss" scoped>
.factoring-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px 0;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
<style lang="scss">
.factoring-container {
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 10px) !important;
  }
  .el-table__fixed-footer-wrapper {
    display: none !important;
  }
}
</style>

